import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import { noop } from 'shell/utils/noop';

interface HistorianFamilyStepButtonsProps {
  onCancel?: () => void;
}

const HistorianFamilyStepButtons = ({
  onCancel,
}: HistorianFamilyStepButtonsProps): React.ReactElement => {
  return (
    <StickyDiv>
      <PmiButton variant="outlined" color="cdmBrand" fullWidth onClick={onCancel || noop}>
        ESCI
      </PmiButton>
    </StickyDiv>
  );
};

HistorianFamilyStepButtons.displayName = 'button form component';

const HistorianFamilyStepButtonsMemo = memo(HistorianFamilyStepButtons);

export default HistorianFamilyStepButtonsMemo;
